import { modals } from "@mantine/modals";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../model/MessageResponse";
import { useDisclosure } from "@mantine/hooks";
import { Box, Button, Flex, Text } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";

const ActiveProduct = ({
  ids,
  onSuccess,
}: {
  ids: string[];
  onSuccess: any;
}) => {
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const handleActiveProduct = async () => {
    open();
    try {
      let url = "/api/v1/TblItem/active-item";

      if (ids && ids.length > 0) {
        url += "?" + ids.map((i) => `Ids=${i}`).join("&");
      }

      const res = await repositoryPos.post<MessageResponse<any>>(url);

      if (res && res.success) {
        NotificationExtension.Success("Đổi trạng thái thành công !");
        setTimeout(() => {
          modals.closeAll();
          onSuccess();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={10} fw={500}>
        Bạn có chắc chắn muốn đổi trạng thái các sản này ?
      </Text>
      <Flex justify="center" mt={10}>
        <Button
          color="teal"
          disabled={visible}
          loading={visible}
          onClick={handleActiveProduct}
          leftSection={<IconCheck size={18} />}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default ActiveProduct;
